/* istanbul ignore file */
import { ShowPageLayout, ShowSection } from 'framework/ui/layout';
import { Show } from 'framework/show';
import useEmployeeContractsService from 'domain/people/employee/contracts/shared/employeeContractsService';
import {
  useEmployeeContractId,
  useEmployeeContractUrl,
} from 'domain/people/employee/contracts/employeeContractRouting';
import EditEmployeeContractButton from 'domain/people/employee/contracts/shared/button/EditEmployeeContractButton';
import DeleteEmployeeContractButton from 'domain/people/employee/contracts/shared/button/DeleteEmployeeContractButton';
import { ContractsViewFields } from 'domain/people/contracts';
import { useNavigate } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import { Button } from 'framework/ui/mui-builder';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';

const ViewEmployeeContract = () => {
  const { getById } = useEmployeeContractsService();
  const id = useEmployeeContractId();
  const { getListUrl } = useEmployeeContractUrl();
  const navigate = useNavigate();

  return (
    <ShowPageLayout
      buttons={[<EditEmployeeContractButton size="small" />, <DeleteEmployeeContractButton size="small" />]}
    >
      <Show getDataMethod={() => getById(id)}>
        <ShowSection
          title={
            <Box display="flex" alignItems="center">
              <Button
                onClick={() => navigate(getListUrl())}
                sx={{ mr: 1, minWidth: 'auto', p: 0.2 }}
                variant="outlined"
              >
                <NavigateBeforeIcon />
              </Button>
              <Typography variant="h4" color="primary">
                View: Contract
              </Typography>
            </Box>
          }
        >
          <ContractsViewFields />
        </ShowSection>
      </Show>
    </ShowPageLayout>
  );
};

export default ViewEmployeeContract;
